module.exports = __webpack_public_path__ + "assets/img/1.f97d4bac.png";